var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',[_c('v-toolbar',{attrs:{"flat":"","dense":""}},[_c('v-toolbar-title',[_vm._v("Bush Droppings")]),_c('v-spacer')],1),_c('v-data-table',{class:_vm.themeClass,attrs:{"headers":_vm.headers,"items":_vm.bushDroppings,"item-key":"kraalID","show-select":"","single-select":true,"items-per-page":50}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }